import React, { useState, useEffect, useMemo } from "react";
import { Spinner, Button } from "reactstrap";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { validateLinkByToken } from "@workspace/common/src/store/link/action";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchPreAssessmentVideo,
  fetchPreAssessmentData,
} from "@workspace/job/src/store/preAssessment/action";
import PreAssessmentPlayBack from "@workspace/job/src/components/RecruiterPreAssessmentPlayback/PreAssessmentPlayBack/PreAssessmentPlayBack";
import PreAssessmentPlayBackStream from "@workspace/job/src/components/RecruiterPreAssessmentPlayback/PreAssessmentPlayBack/PreAssessmentPlayBackStream";
import { Transcript } from "@workspace/common";
import LoadingOverlay from "react-loading-overlay";

const JobPortalSelfAssessmentPlayback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pageLoading, setPageLoading] = useState(true);
  const { selfAssessmentId } = useParams();
  const [videoPreviewUrl, setVideoPreviewUrl] = useState(null);
  const [showTranscript, setShowTranscript] = useState(true);

  const preAssessmentVideoUrl = useSelector(
    (state) => state.PreAssessmentReducer.preAssessmentVideo
  );
  const preAssessmentData = useSelector(
    (state) => state.PreAssessmentReducer.PreAssessmentData
  );

  const preAssessementDataLoading = useSelector(
    (state) => state.PreAssessmentReducer.PreAssessmentDataLoading
  );

  const preAssessmentVideoLoading = useSelector(
    (state) => state.PreAssessmentReducer.preAssessmentVideoLoading
  );

  // Memoize videoSrc
  const videoSrc = useMemo(() => videoPreviewUrl, [videoPreviewUrl]);

  // Memoize botTimestamps
  const botTimestamps = useMemo(
    () =>
      preAssessmentData?.timeStamp
        ? JSON.parse(preAssessmentData.timeStamp)
        : null,
    [preAssessmentData?.timeStamp]
  );

  // Memoize chatHistory
  const chatHistory = useMemo(
    () =>
      preAssessmentData?.chatHistory
        ? JSON.parse(preAssessmentData.chatHistory)
        : null,
    [preAssessmentData?.chatHistory]
  );

  if (!selfAssessmentId) {
    navigate("/job-portal/home");
  }

  // Action - Handle open video
  const handleConvertVideo = async (urlResponse) => {
    try {
      const url = window.URL.createObjectURL(
        new Blob([urlResponse], { type: "video/mp4" })
      );
      setVideoPreviewUrl(url);
    } catch (e) {
      console.error("Error in handleOpenVideo: ", e);
    }
  };

  useEffect(() => {
    if (preAssessmentVideoUrl) {
      handleConvertVideo(preAssessmentVideoUrl);
    }
  }, [preAssessmentVideoUrl]);

  useEffect(() => {
    if (selfAssessmentId) {
      dispatch(
        fetchPreAssessmentData({
          id: selfAssessmentId,
          status: "INPROGRESS_COMPLETED",
        })
      );
    }
  }, [selfAssessmentId]);

  useEffect(() => {
    if (
      preAssessmentData &&
      "isStream" in preAssessmentData &&
      !preAssessmentData?.isStream
    ) {
      dispatch(
        fetchPreAssessmentVideo({
          id: selfAssessmentId,
          status: "INPROGRESS_COMPLETED",
        })
      );
    }
  }, [preAssessmentData?.isStream]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("q");
    if (!token) {
      navigate("/jobportal");
    }
    dispatch(
      validateLinkByToken(
        {
          token,
        },
        navigate,
        setPageLoading
      )
    );
  }, [location.search, navigate]);

  if (pageLoading) {
    <div className="d-flex align-items-center justify-content-center">
      <Spinner color="primary" />
    </div>;
  }

  return (
    <LoadingOverlay
      active={preAssessementDataLoading || preAssessmentVideoLoading || false}
      spinner
      text="Loading self-assessment data...please wait"
    >
      <div
        className="d-flex"
        style={{
          minHeight: "100vh",
          backgroundColor: "#FFFFFF",
        }}
      >
        <div
          className=" flex-grow-1 align-items-center"
          style={{
            padding: "2px 20px",
          }}
        >
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              height: "7.5vh",
            }}
          >
            <div>
              <div className="d-flex gap-2 align-items-center">
                <span
                  className="px-2 rounded-3"
                  style={{
                    backgroundColor: "#0A56AE",
                    color: "#fff",
                    paddingTop: "2px",
                    paddingBottom: "2px",
                  }}
                >
                  Pre-assessment
                </span>
                <span className="fw-semibold fs-5">
                  {preAssessmentData?.job?.jobSubmissionData?.jobTitle}
                </span>
                <span className="fw-semibold fs-5">|</span>
                <span className="fw-semibold fs-5">
                  {preAssessmentData?.job?.jobSubmissionData?.jobId}
                </span>
              </div>
              <div
                className="d-flex gap-2 mt-1"
                style={{
                  color: "#0A56AE",
                }}
              >
                <span>
                  {
                    preAssessmentData?.candidate?.candidateSubmissionData
                      ?.firstName
                  }
                </span>
                <span>
                  {
                    preAssessmentData?.candidate?.candidateSubmissionData
                      ?.lastName
                  }
                </span>
              </div>
            </div>
            {!showTranscript && (
              <Button
                className="cursor-pointer"
                style={{
                  backgroundColor: "#0A56AE",
                  color: "#fff",
                  borderRadius: "12px",
                }}
                onClick={() => {
                  setShowTranscript(!showTranscript);
                }}
              >
                <i className="ri-file-list-3-line fs-4"></i>
              </Button>
            )}
          </div>
          <div
            className="mt-3"
            style={{
              maxHeight: "90vh",
              padding: "15px 10px",
            }}
          >
            {preAssessmentData?.isStream ? (
              <PreAssessmentPlayBackStream
                botTimestamps={botTimestamps}
                videoSrc={videoPreviewUrl}
                chatHistory={chatHistory}
                selfAssessmentId={selfAssessmentId}
                jobId={preAssessmentData?.job?.id}
              />
            ) : (
              <PreAssessmentPlayBack
                botTimestamps={botTimestamps}
                videoSrc={videoPreviewUrl}
                chatHistory={chatHistory}
              />
            )}
          </div>
        </div>
        {showTranscript && (
          <div
            style={{
              minWidth: "27.5%",
              maxWidth: "27.5%",
              borderLeft: "1px solid #e5e5e5",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#EEF3F8",
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                padding: "10px 15px",
                height: "7.5vh",
              }}
            >
              <span className="fw-semibold fs-4">Transcript</span>
              <i
                className="ri-close-line fs-3 cursor-pointer"
                onClick={() => {
                  setShowTranscript(false);
                }}
              ></i>
            </div>
            <div
              style={{
                padding: "0px",
                height: "92.5vh",
                overflowY: "auto",
              }}
            >
              <Transcript
                chatHistory={
                  preAssessmentData?.chatHistory
                    ? JSON.parse(preAssessmentData?.chatHistory)
                    : null
                }
                aiAlias="Interviewer"
                userAlias="Candidate"
              />
            </div>
          </div>
        )}
      </div>
    </LoadingOverlay>
  );
};

export default JobPortalSelfAssessmentPlayback;
